import React from "react";
import LeagMainHead from "../../common/LeagMainHead";
import InfoPage from "../../football/league/InfoPage";
import LeagueWrapper from "../../football/league/LeagueWrapper";
import RugbyStandingTable from "../../rugby/RugbyStandingTable";

const RugbyLeagueWidgetWrap = (props) => {
    const {
        dataId,
        dataType,
        head,
        data,
        headData,
        baseUrl,
        sport,
        difference,
        loadCSS,
        dataClient,
        websiteBaseUrl,
        dataPath,
        dataTitle,
        setDataType,
        setDataId,
        setHead,
    } = props;

    const renderHeadWrap = (currentTab, children) =>
        head ? (
            <LeagMainHead
                id={dataId}
                headData={headData}
                baseUrl={baseUrl}
                sport={"rugby"}
                dataClient={dataClient}
                currentTab={currentTab}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                widgetTitle={dataTitle}

            >
                {children}
            </LeagMainHead>
        ) : (
            children
        );

    switch (dataType) {
        case "rugby-league-info":
            return renderHeadWrap("info",
                <InfoPage
                    id={dataId}
                    sport={sport}
                    data={data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    setDataType={setDataType}
                    setDataId={setDataId}
                    setHead={setHead}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );

        case "rugby-league-upcoming":
            return renderHeadWrap("upcoming",
                <LeagueWrapper
                    sport={sport}
                    data={data?.data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );

        case "rugby-league-results":
            return renderHeadWrap("results",
                <LeagueWrapper
                    sport={sport}
                    data={data?.data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                    showTime={true}
                />
            );
        case "rugby-league-standings":
            return renderHeadWrap("table",
                <RugbyStandingTable
                    sport={sport}
                    ServerData={data}
                    loadCSS={loadCSS}
                    dataClient={dataClient}
                />
            );

        default:
            return <h1>Rugby League Widget Not Found!</h1>;
    }
};

export default RugbyLeagueWidgetWrap;
